
import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
// import Breadcrumb from "../components/Breadcrumb";
import Layer from "../components/LeadershipTeamFormLayer";

const LeadershipTeamFormPage = () => {
  return (
    <>
      <MasterLayout>
        {/* <Breadcrumb title="Leadership / Team Section" /> */}
        <Layer />
      </MasterLayout>
    </>
  );
};
export default LeadershipTeamFormPage;
